"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Main = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var Main = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Main, _super);
    function Main() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷我的额度接口';
        _this.code = '101115';
        _this.desc = '现金贷我的额度接口';
        _this.requestParams = new cashLoanAuth_1.MainRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Main;
}(service_1.BaseService));
exports.Main = Main;
//# sourceMappingURL=main.js.map